// features/salary/salaryService.ts
import { calculateInvoiceAmount, calculateNetSalary , calculateGrossSalary } from '../../api/salarycalculator/index';

export const calculateamountSalary = async (payload: any) => {
  const response = await calculateInvoiceAmount(payload);
  return response;
};
export const calculateNetSalaryApi  = async (payload: any) => {
  const response = await calculateNetSalary(payload);
  return response;
};
export const calculateGrossSalaryApi  = async (payload: any) => {
  const response = await calculateGrossSalary(payload);
  return response;
}

